import React from "react";
import TypeAnimation from "react-type-animation";

function Projects() {
  return (
    <>
      <h1
        className="water-brush title my-4"
        style={{ margin: "auto", float: "none" }}
      >
        Projects/Works
      </h1>

      <div className="container-fluid px-5">
        <div className="text-sm-start mb-4">
          ${" "}
          <TypeAnimation
            cursor={true}
            sequence={[
              "",
              2000,
              "cd .\\github\\My_GitHub_Repositories",
              3000,
              "ls",
              3000,
            ]}
            className="roboto-mono type-green"
            wrapper="span"
            repeat={Infinity}
          />
        </div>
        <div
          className="col-lg-12 col-sm-12 projects-list"
          style={{ float: "none", margin: "auto" }}
        >
          <a
            href="https://github.com/lasyanga/digital-clock"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=digital-clock&theme=react"
              alt=""
            />
          </a>

          <a
            href="https://github.com/lasyanga/sentiment-analyzer"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=sentiment-analyzer&theme=react"
              alt=""
            />
          </a>

          <a
            href="https://github.com/lasyanga/number-system-conversion-java"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=number-system-conversion-java&theme=react"
              alt=""
            />
          </a>

          <a
            href="https://github.com/lasyanga/java-calculator-with-gui"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=java-calculator-with-gui&theme=react"
              alt=""
            />
          </a>
          <a
            href="https://github.com/lasyanga/simple-login-system-java"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=simple-login-system-java&theme=react"
              alt=""
            />
          </a>
          <a
            href="https://github.com/lasyanga/simple-program-java"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=simple-program-java&theme=react"
              alt=""
            />
          </a>

          <a
            href="https://github.com/lasyanga/simple-calculator"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=simple-calculator&theme=react"
              alt=""
            />
          </a>
          <a
            href="https://github.com/lasyanga/area-of-circle-with-gui"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=area-of-circle-with-gui&theme=react"
              alt=""
            />
          </a>
          <a
            href="https://github.com/lasyanga/tula"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=tula&theme=react"
              alt=""
            />
          </a>
          <a
            href="https://github.com/lasyanga/student-portal"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=Student-portal&theme=react"
              alt=""
            />
          </a>
        </div>

        {/* <div className="text-sm-start my-4">
          ${" "}
          <TypeAnimation
            cursor={true}
            sequence={[
              "",
              1000,
              "cd .\\published\\Web_Development",
              3000,
              "ls",
              3000,
            ]}
            repeat={Infinity}
            wrapper="span"
            className="roboto-mono type-green"
          />
        </div>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <img
              className="img-fluid m-1"
              src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=Student-portal&theme=react"
              alt=""
            />
            <div classname="card" style={{ width:"3rem" }}>
              <img src="https://github-readme-stats.vercel.app/api/pin/?username=Lasyanga&repo=Student-portal&theme=react" classname="card-img-top" alt="..." />
              <div classname="card-body">
                <p classname="card-text">
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default Projects;
